// 第一次请求在访问中，
// 第二次请求在访问中，等待
// 第n次请求在访问中，等待
// 访问结束，n次都返回结果
class CacheFunction {
  /**
   * @param {*} getResultFun 获取结果的方法
   * @param {*} isRetry 是否重试一次，例如 key 过期这种，需要重试一次，重新获取 key
   */
  constructor(getResultFun, isRetry = true) {
    this.requestArr = []
    this.isRequesting = false
    this.result = null
    this.getResultFun = getResultFun
    this._isRetry = isRetry
  }

  async _getResult() {
    console.log('[cache]获取开始')
    let result
    try {
      result = await this.getResultFun()
    } catch (e) {
      if (this._isRetry) {
        // 重试一次
        console.log('[cache]重试一次')
        result = await this.getResultFun()
      } else {
        return Promise.reject(e)
      }
    }
    console.log('[cache]获取结束')
    this.result = result
    return result
  }

  _dealCbs(result) {
    const { requestArr } = this
    requestArr.forEach(cb => {
      cb(result)
    })
    this.requestArr = []
  }

  _requestResult(cb) {
    if (this.result) {
      console.log('[cache]从缓存中获取 result ', this.result)
      cb(this.result)
      return
    }
    this.requestArr.push(cb)
    if (this.isRequesting) {
      // 正在请求中
      return
    }
    this.isRequesting = true
    this._getResult().then(result => {
      this._dealCbs(result)
    }).catch(e => {
      console.log('[cache]获取失败', e)
      this._dealCbs(e)
    }).finally(() => {
      this.isRequesting = false
    })
  }

  getResult() {
    return new Promise((resolve, reject) => {
      this._requestResult(result => {
        if (result instanceof Error) {
          return reject(result)
        }
        return resolve(result)
      })
    })
  }
}

export default CacheFunction